import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { A11y, Keyboard, Navigation } from 'swiper';
SwiperCore.use([A11y, Keyboard, Navigation]);
import ProductImage from '@stone/components/product/ProductImage';
const ProductShopTheLookInfo = (props) => {
    const { current } = props;
    const { t } = useTranslation();
    const [activeSlide, setActiveSlide] = useState(0);
    const onLookClick = (lookIndex) => {
        customEventBus.emit('shopthelook:quickbuy', { lookIndex: lookIndex });
    };
    const looks = useMemo(() => {
        var _a;
        return (_a = current === null || current === void 0 ? void 0 : current.lookProducts) === null || _a === void 0 ? void 0 : _a.filter((l) => l !== null);
    }, [current]);
    //* SECTION - RENDER --------------------------------------------------------------------
    if (!looks || looks.length <= 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "shopthelook" },
        React.createElement("div", { className: "shopthelook-infopanel" },
            React.createElement("div", { className: "shopthelook-upper" },
                React.createElement("span", { className: "shopthelook-title font__title" }, t('label.shopthelook')),
                looks.length > 3 && (React.createElement("div", { className: "shopthelook__arrow-container" },
                    React.createElement("button", { className: "shopthelook__arrow shopthelook__arrow-left swiper-button-prev", disabled: activeSlide <= 0, "aria-label": t('carousel.prevslidemessage') },
                        React.createElement("i", { className: "icon--10-left-chevron", "aria-hidden": true })),
                    React.createElement("button", { className: "shopthelook__arrow shopthelook__arrow-right swiper-button-next", disabled: activeSlide >= (looks === null || looks === void 0 ? void 0 : looks.length) - 1, "aria-label": t('carousel.nextslidemessage') },
                        React.createElement("i", { className: "icon--10-right-chevron", "aria-hidden": true }))))),
            React.createElement("div", { className: "shopthelook-items" },
                React.createElement(Swiper, { className: "swiper-container", slidesPerView: 3, slidesPerGroup: 1, watchSlidesProgress: true, spaceBetween: 12, a11y: {
                        enabled: true,
                        slideRole: 'group',
                        itemRoleDescriptionMessage: 'slide',
                        slideLabelMessage: '',
                        prevSlideMessage: t('label.prevslidemessage'),
                        nextSlideMessage: t('label.nextslidemessage'),
                    }, navigation: {
                        nextEl: '.shopthelook__arrow-right',
                        prevEl: '.shopthelook__arrow-left',
                    }, slideToClickedSlide: false, onSlideChange: (swiper) => setActiveSlide(swiper.activeIndex) }, looks.map((look, i) => (React.createElement(SwiperSlide, { key: look.uuid },
                    React.createElement("button", { type: "button", className: "button", onClick: () => onLookClick(i) },
                        React.createElement(ProductImage, { img: look === null || look === void 0 ? void 0 : look.imgs, type: "F" }))))))))));
};
export default ProductShopTheLookInfo;
